/**
 * @generated SignedSource<<d4d83a442eef74e005bd64d7f4f649fd>>
 * @relayHash b5b954d838287f5d389dc0271bb50289
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID de7d6f9082a817f04aa908b91d0e4deb2879b8d925e888a99dfc317c8c3e18d0

import type { ConcreteRequest } from 'relay-runtime';
export type ProjectCapabilitiesQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type ProjectCapabilitiesQuery$data = {
  readonly projects_capabilities?: {
    readonly canCreateProject: boolean | null | undefined;
    readonly canExportProjects: boolean | null | undefined;
  } | null | undefined;
};
export type ProjectCapabilitiesQuery = {
  response: ProjectCapabilitiesQuery$data;
  variables: ProjectCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "condition": "isM3GroupPermsEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          }
        ],
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          },
          {
            "kind": "ScalarField",
            "name": "canExportProjects"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "de7d6f9082a817f04aa908b91d0e4deb2879b8d925e888a99dfc317c8c3e18d0",
    "metadata": {},
    "name": "ProjectCapabilitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e48b4e169ba51c25564e9c6c55242c86";

export default node;
